import baseRoute from '../baseRoute';

export type * from './viewModel';
export type * from './queryParams';

type RouteDefinition = `${typeof baseRoute}/csv/list${`?query=${string}${`&isDeleted=${boolean}` | ''}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}/csv/list`;

export const URL = (searchText = '', isDeleted?: boolean): RouteDefinition => {
	const isDeletedQuery = isDeleted === undefined ? '' : `&isDeleted=${isDeleted}`;

	return `${baseRoute}/csv/list?query=${searchText}${isDeletedQuery}`;
};
